import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { fetchRecurringReport_ac } from '../../../actions/report_recurring.ac';
import { dateFormat } from '../../../util/date';
import Recurring from '../Recurring/Recurring';

const INITIAL_FILTERS = {
  from: moment().startOf('day').add(7, 'days').toDate(),
  to: moment().startOf('day').add(7, 'days').toDate(),
};

const PaChecks = (props) => {
  const { recurringReport, fetchRecurringReport } = props;

  const [filters, setFilters] = useState({ ...INITIAL_FILTERS });

  const formatDate = useMemo(
    () => ({
      from: dateFormat(filters.from),
      to: dateFormat(filters.to),
    }),
    [filters]
  );

  const handleDateChange = (name, value) => {
    setFilters((filters) => ({
      ...filters,
      [name]: value,
    }));
  };

  useEffect(() => {
    fetchRecurringReport(formatDate);
  }, [fetchRecurringReport, formatDate]);

  const handlePageChange = (newPage) => {
    fetchRecurringReport(formatDate, newPage - 1);
  };

  const applyFilters = () => {
    fetchRecurringReport(formatDate);
  };

  const handleClearFilters = () => {
    setFilters({ ...INITIAL_FILTERS });
  };

  return (
    <Recurring
      filters={filters}
      isDisplayImage={true}
      applyFilters={applyFilters}
      data={recurringReport.report}
      handlePageChange={handlePageChange}
      handleDateChange={handleDateChange}
      isLoading={recurringReport.isFetching}
      handleClearFilters={handleClearFilters}
    />
  );
};

const mapStateToProps = (stateFromStore) => ({
  recurringReport: stateFromStore.recurringReport,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchRecurringReport: fetchRecurringReport_ac,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PaChecks);
